export default (linkedDefinitions) => ({
    name: "has_linked_operation",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'has linked operation %1',
                "args0": [
                    {
                        "type": "field_dropdown",
                        "name": "LINK_DEFINITION",
                        "options": [
                            ...linkedDefinitions.map((obj) => [obj.name, obj.id])
                        ]
                    }
                ],
                "output": null,
                "colour": 4.5,
                "tooltip": "Creates cash event with specified parameters",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        let linkDefinitionId = block.getFieldValue("LINK_DEFINITION");

        return [`linkedOperations.get('${linkDefinitionId}') != null`, blocklyInstance.JavaScript.ORDER_NONE];
        ;
    }
})